import { SYSTEM_VARIABLE_CATALOG, isAnyCatalogLabel, normalizeVariableLabel } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariables.utils';
export const CATEGORY_ORDER = [
    'This notification',
    'Primary contact',
    'Client',
    'My Business',
    'Agreement'
];
const NOTIFICATION_ONLY_CATEGORIES = [
    'This notification',
    'Primary contact'
];
function groupSystemVariablesByCategory(filteredSystemVars) {
    const grouped = new Map();
    for (const category of CATEGORY_ORDER){
        const entries = filteredSystemVars.filter((v)=>v.category === category);
        if (entries.length > 0) {
            grouped.set(category, entries);
        }
    }
    return grouped;
}
export function buildSelectableItems(customVariables, excludeLabels) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const { allowedSystemKeys } = options;
    const filteredSystem = SYSTEM_VARIABLE_CATALOG.filter((v)=>!excludeLabels.has(normalizeVariableLabel(v.label))).filter((v)=>{
        if (allowedSystemKeys != null) return allowedSystemKeys.has(v.key);
        return !NOTIFICATION_ONLY_CATEGORIES.includes(v.category);
    });
    const grouped = groupSystemVariablesByCategory(filteredSystem);
    const items = [];
    for (const [category, entries] of grouped){
        for (const entry of entries){
            items.push({
                type: 'variable',
                label: entry.label,
                category,
                subcategory: 'subcategory' in entry ? entry.subcategory : undefined
            });
        }
    }
    for (const label of customVariables){
        items.push({
            type: 'variable',
            label,
            category: 'Custom'
        });
    }
    return items;
}
export function canCreateVariable(searchText, customVariables) {
    const trimmed = searchText.trim();
    if (trimmed.length === 0) return false;
    return !isAnyCatalogLabel(trimmed) && !customVariables.some((v)=>normalizeVariableLabel(v) === normalizeVariableLabel(trimmed));
}
export function getCategoryForItem(items, index) {
    var _item_subcategory, _prevItem_subcategory;
    const item = items[index];
    const currentHeader = (_item_subcategory = item.subcategory) !== null && _item_subcategory !== void 0 ? _item_subcategory : item.category;
    if (index === 0) {
        return currentHeader;
    }
    const prevItem = items[index - 1];
    const prevHeader = (_prevItem_subcategory = prevItem.subcategory) !== null && _prevItem_subcategory !== void 0 ? _prevItem_subcategory : prevItem.category;
    if (item.category !== prevItem.category || currentHeader !== prevHeader) {
        return currentHeader;
    }
    return null;
}
